import { useCallback, useEffect, useState } from "react"
import { get } from "helpers/api_helper"

export default function usePhaseContext(eventId, competitionId) {
  const [version, setVersion] = useState(0)
  const [state, setState] = useState({ loading: true, data: null, error: false })
  const reload = useCallback(() => setVersion(value => value + 1), [])
  useEffect(() => {
    let active = true
    setState({ loading: true, data: null, error: false })
    get(`/admin/events/${eventId}/competitions/${competitionId}/phase-context`)
      .then(response => {
        if (!Array.isArray(response?.data?.phases) || response.data.eventId !== eventId || response.data.competitionId !== competitionId) throw new Error("PHASE_CONTEXT_UNAVAILABLE")
        if (active) setState({ loading: false, data: response.data, error: false, scope: `${eventId}:${competitionId}` })
      })
      .catch(() => { if (active) setState({ loading: false, data: null, error: true, scope: `${eventId}:${competitionId}` }) })
    return () => { active = false }
  }, [eventId, competitionId, version])
  return { ...(state.scope === `${eventId}:${competitionId}` ? state : { loading: true, data: null, error: false }), reload }
}
